interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <div className="flex-shrink-0 w-32 h-24 mr-1">
        <img
          src="/synced-logo.png"
          alt="SyncED Logo"
          className="w-full h-full object-contain"
        />
      </div>
      <div>
        <h1 className="text-2xl font-bold text-white">SyncED</h1>
        <p className="text-sm text-lime-100">Bridging educators with student needs</p>
      </div>
    </div>
  );
};

export default Logo; 